import { Pipe, PipeTransform } from '@angular/core';
import { ConfigService } from '../services/config.service';

@Pipe({
  name: 'printerName'
})
export class PrinterNamePipe implements PipeTransform {

  constructor(private config: ConfigService) {}

  transform(printerId: any = null): any {
      const printers = this.config.config.com_server.devices?.printers
      for(let printer of printers){
          if (printer.id == printerId){
              return printer.mapName;
          }
      }
  }
}
